<template>
  <footer>
    <div class="container-fluid footer">
      <span>#The F2E 3rd Week01 #Breakfast </span>
    </div>
  </footer>
</template>
